// BM-H398 - the consequence of a non-administrative mirror divergence.
//
// MIRROR_SPLIT_MESSAGE names no section by design. The point of difference
// is listed separately below it, from `divergedSections`, so the client can
// see what differed without the regulatory copy being edited.

import BlockCopyView from "./BlockCopyView";
import { MIRROR_SPLIT_MESSAGE } from "./copySentinels";
import { sectionLabel } from "./sectionRegistry";

export default function MirrorSplitNotice({ divergedSections = [] }) {
  return (
    <div data-testid="mirror-split-notice">
      <BlockCopyView copy={MIRROR_SPLIT_MESSAGE} testid="mirror-split-message" role="status" />
      {divergedSections.length > 0 && (
        <p data-testid="mirror-split-sections" style={{ fontSize: 13, marginTop: -8, marginBottom: 20 }}>
          Where your answers differ: {divergedSections.map(sectionLabel).join(", ")}.
        </p>
      )}
    </div>
  );
}
